import { ProfilePage } from '@mobi/web';

export function Profile() {
  return <ProfilePage />;
}
